import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Componente para proteger rotas com base na autenticação e permissões do usuário.
 * @param {React.Component} component Componente a ser renderizado se autorizado
 * @param {string[]} requiredPermissions Permissões necessárias para acessar a rota
 * @param {...} rest Outras props passadas para a rota
 */
const ProtectedRoute = ({ component: Component, requiredPermissions = [], ...rest }) => {
  const { currentUser } = useAuth();
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }


  const userPermissions = currentUser.permissions || []; 

  const hasPermission = requiredPermissions.length === 0 || requiredPermissions.some(p => userPermissions.includes(p));

  if (!hasPermission && currentUser.role !== 'master') {
    return <Navigate to="/access-denied" replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
